import makeFetch from "../../utils/http";

export function api_createCredit(body) {
    return makeFetch(
        "credits",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_getCreditRequestsCount() {
    return makeFetch(
        "creditRequests/count",
        "GET",
        {
            creditStatus: "CREATED",
            creditRequestTypes: ["DEFAULT", "ADVICE"],
        }
    );
}

export function api_getCreditRequestsCountByType(creditRequestTypes) {
    return makeFetch(
        "creditRequests/count",
        "GET",
        {
            creditStatus: "CREATED",
            creditRequestTypes: creditRequestTypes
        }
    );
}

export function api_getCreditPrices(usState, type) {
    return makeFetch(
        "credits/prices",
        "GET",
        usState ? {
            creditTypes: type,
            usState: usState
        }
        : {
            creditTypes: type
        }
    );
}

export function api_getCreditRequests(creditRequestTypes) {
    return makeFetch(
        "creditRequests",
        "GET",
        {
            creditStatus: "CREATED",
            creditRequestTypes: creditRequestTypes,
        }
    );
}

export function api_getCreditsByUserId() {
    return makeFetch(
        "credits",
        "GET",
        {creditStatuses: ["CREATED"]}
    );
}

export function apiGetCreditsById(userId, creditRequestTypes) {
    return makeFetch(
        "credits",
        "GET",
        {userId, creditStatuses: ["CREATED", "APPLIED", "EXPIRED"], creditRequestTypes}
    );
}

export function api_setInvoicePreview(body) {
    return makeFetch(
        "invoices/credits/previews",
        "POST",
        {},
        JSON.stringify(body)
    );
}
